import { AfterViewInit, Component, ElementRef, OnInit,ViewChild,ViewEncapsulation } from '@angular/core';
import { ConfirmationService, ConfirmEventType, LazyLoadEvent, MenuItem, MessageService, PrimeNGConfig } from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DataService, SharedService } from 'src/app/shared/services';
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { IUserDetails } from 'src/app/admin/models/user.model';
import { VendorOnboardApprovalSearchService } from 'src/app/admin/services/vendor-onboard-approval-search.service';
import { Router,NavigationStart } from '@angular/router';
import { JwtService } from 'src/app/auth/services';
import { IVendorOnboardApprovalEmailLinkResend, IVendorOnboardApprovalEmailAdd } from '../../models/vendor-onboard-approval-search.model';
import * as fs from 'file-saver';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { LookupCategory, DocTemplateLogo, MSAType, VendorOnboardProcessStatus } from 'src/app/shared/enums/EnumsVMS';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { DocViewerDialogComponent } from 'src/app/doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
import { User} from '../../../auth/models';
import { BackToSearchService } from 'src/app/shared/services';
var htmlToPdfmake = require("html-to-pdfmake");
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DomSanitizer } from '@angular/platform-browser';
import { Console } from 'console';
(<any>pdfMake).vfs = pdfFonts?.pdfMake?.vfs;
(<any>pdfMake).fonts = {
  leckerli: {
    normal: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    bold: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    italics: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    bolditalics: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`
  },
  cedarvillecursiveFont: {
    normal: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    bold: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    italics: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    bolditalics: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`
  },
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
}
@Component({
  selector: 'app-vendor-onboard-approval-search',
  templateUrl: './vendor-onboard-approval-search.component.html',
  styleUrls: ['./vendor-onboard-approval-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class VendorOnboardApprovalSearchComponent implements OnInit, AfterViewInit {
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  vendorOnboardApprovalList;
  gridSpinner = 'gridSpinner1';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  vendorOnboardApprovalSearchParam:IGlobalSearchParam;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  showAddRuleButtonCO:boolean = false;
  showAddRuleButtonMO:boolean = false;
  showAddRuleButtonVSO:boolean = false;
  vendorOnboardApprovalSearchSpinner = 'vendorOnboardApprovalSearchSpinner';
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  gridGlobalFilter: SelectItem[];
  showTopFilters: boolean;
  menuItems: MenuItem[];
  activeItem: MenuItem;
  displayModal:boolean = false;
  // userActionDescription:string;
  // notes;
  // notesList;
  // companyId:number;
  showToggle:boolean;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
  isshowpaginator:boolean=true;
  matchModeOptionsForDropdown: SelectItem[];
  msaTemplateStatus:any;
  selectedMSATemplateStatus:any;
  public selectedMSATemplateStatusId:Array<any> = [];
  poTemplateStatus:any;
  selectedPOTemplateStatus:any;
  public selectedPOTemplateStatusId:Array<any> = [];
  ncaStatus:any;
  selectedNCATemplateStatus:any;
  public selectedNCATemplateStatusId:Array<any> = [];
  documentTemplateSearchValues:any;
  selectedinsuranceExhibitTemplateStatus:any;
  public selectedinsuranceExhibitTemplateStatusId:Array<any> = [];
  selectedIsEmailSentStatus:any;
  public selectedIsEmailSentStatusId:Array<any> = [];

  allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'vendorName', header: 'Vendor' },
    { value: 'statusName', header: 'Status' },
    { value: 'msaType', header: 'Employment Type' },
    { value: 'isMSATemplateAvailable', header: 'MSA' },
    { value: 'isPOTemplateAvailable', header: 'PO' },
    { value: 'isNCATemplateAvailable', header: 'NCA' },
    { value: 'insuranceExhibitId', header: 'Insurance Exhibit A' },
    { value: 'isEmailSent', header: 'Is Email Sent' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedByName', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' },
    { value: 'submittedByEmail', header: 'Submitted By' },
    { value: 'vendorSubmittedOn', header: 'Submitted On' },
  ];

  defaultSelectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'vendorName', header: 'Vendor' },
    { value: 'statusName', header: 'Status' },
    { value: 'msaType', header: 'Employment Type' },
    { value: 'isMSATemplateAvailable', header: 'MSA' },
    { value: 'isPOTemplateAvailable', header: 'PO' },
    { value: 'isNCATemplateAvailable', header: 'NCA' },
    { value: 'insuranceExhibitId', header: 'Insurance Exhibit A' },
    { value: 'isEmailSent', header: 'Is Email Sent' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedByName', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' },
    { value: 'submittedByEmail', header: 'Submitted By' },
    { value: 'vendorSubmittedOn', header: 'Submitted On' },
  ];

  selectedColumns = []
  items: MenuItem[];
  itemsAfterEmailInitiate: MenuItem[];
  itemsAfterVendorSubmission: MenuItem[];
  itemsOthers: MenuItem[];
  itemsAfterEmailInitiateForC2C: MenuItem[];
  itemsAfterVendorSubmissionForC2C: MenuItem[];
  itemsOthersForC2C: MenuItem[];
  selectedGridMenuItem:any = null;
  @ViewChild('dt2', { static: true }) table: any;
  createdOnFilterValue: any;
  modifiedOnFilterValue: any;
  submittedOnFilterValue: any;
  tempEventFirst:any=0;
  backToSearchData = null;
  allVendorOnboardApprovalStatus: ILookupCategory;
  arrAllVendorOnboardApprovalStatus:any;
  vendorOnboardApprovalStatusId: any;
  vendorOnboardApprovalStatus:any;
  selectedVendorOnboardApprovalStatus:any;
  public selectedVendorOnboardApprovalStatusId:Array<any> = [];
  allMSAType: ILookupCategory;
  arrAllMSAType:any;
  MSATypeId: any;
  MSAType:any;
  selectedMSAType:any;
  public selectedMSATypeId:Array<any> = [];
  vendorOnboardApprovalHistoryList: any;
  vendorOnboardApprovalHistoryModal: boolean = false;
  vendorOnboardApprovalHistoryTitle:string="";
  vendorOnboardApprovalHistoryDescriptionModal: boolean = false;
  vendorOnboardApprovalCommentsModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }]
    ], 
  };

  viewDocumentTemplateModal: boolean = false;
  isEmailLinkResendDialog: boolean=false;
  emailLinkResendDialogTitleC2C:string="";
  emailLinkResendDialogTitle1099:string="";
  isEmailLinkResendNCADialog: boolean=false;
  emailLinkResendDialogTitleNCA:string="";
  emailLinkResendEmailAdd: IVendorOnboardApprovalEmailAdd[];
  emailLinkResendForm: FormGroup;
  emailLinkResendNCAForm: FormGroup;
  loggedInUserProfile: User;
  tempVendorId: any;
  emailLinkRefId: any;
  statusId: any;
  tempStatus: any;
  loadingSaveButton: boolean = false;
  // logo = 'data:image/png;base64,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';
  logoOnLeft :string = DocTemplateLogo.DevCareLogo;
  logoOnRight: string = DocTemplateLogo.CMMIISOLogo;
  blobFile;
  isC2CVendor:boolean;
  allEmailLinkValidityHours: any[] = [];
  emailLinkValidityHoursId: number;
  emailLinkValidityHours: string;
  public selectedEmailLinkValidityHoursId: Array<any> = [];
  emailInitiated1099: MenuItem[];
  emailInitiatedC2C: MenuItem[];
  submittedByVendor1099: MenuItem[];
  submittedByVendorC2C: MenuItem[];
  vendorLinkReinitiated1099: MenuItem[];
  vendorLinkReinitiatedC2C: MenuItem[];
  ncaLinkReinitiatedWithVendorOnboarded: MenuItem[];
  ncaLinkReinitiatedWithOutVendorOnboarded: MenuItem[];
  vendorOnboarded1099: MenuItem[];
  vendorOnboardedC2CWithNcaNotApproved: MenuItem[];
  vendorOnboardedC2CWithNcaApproved: MenuItem[];
  pendingApprovalTemplateModifiedTemplateRejected1099: MenuItem[];
  pendingApprovalTemplateModifiedTemplateRejectedC2C: MenuItem[];
  submittedByApplicantC2CWithVendorOnboarded: MenuItem[];
  submittedByApplicantC2CWithOutVendorOnboarded: MenuItem[];
  onlyNCASelected:boolean = false;

  constructor(
    private vendorOnboardApprovalSearchService:VendorOnboardApprovalSearchService,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private fb:FormBuilder,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private router: Router,
    private dataService:DataService,
    private jwtService:JwtService,
    public datePipe: DatePipe,
    private backToSearchService: BackToSearchService,
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);

    

  this.emailInitiated1099 = [
  {
    label:'Resend Email Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

  this.emailInitiatedC2C = [
  {
    label:'Resend Vendor Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
   },
   {
    label:'Resend NCA Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
   },
   {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

  this.submittedByVendor1099 = [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
  {
    label:'Resend Email Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

  this.submittedByVendorC2C = [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
   {
    label:'Resend Vendor Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
   },
  {
    label:'Resend NCA Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
   }, 
   {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

this.submittedByApplicantC2CWithVendorOnboarded= [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
  {
    label:'Resend NCA Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
   }, 
   {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

this.submittedByApplicantC2CWithOutVendorOnboarded= [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
   {
    label:'Resend Vendor Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
   },
  {
    label:'Resend NCA Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
   }, 
   {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];


  this.vendorLinkReinitiated1099 = [
  {
    label:'Resend Email Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

  this.vendorLinkReinitiatedC2C = [
  {
   label:'Resend Vendor Link',
   icon:'pi pi-fw pi-pencil',
   command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
  },
 {
   label:'Resend NCA Link',
   icon:'pi pi-fw pi-pencil',
   command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
  }, 
  {
   label:'Download NCA',
   icon:'pi pi-download',
   command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
  },
  {
   label:'History',
   icon:'pi pi-eye',
   command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
  },
];

  this.ncaLinkReinitiatedWithVendorOnboarded = [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
 {
   label:'Resend NCA Link',
   icon:'pi pi-fw pi-pencil',
   command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
  }, 
  {
   label:'Download NCA',
   icon:'pi pi-download',
   command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
  },
  {
   label:'History',
   icon:'pi pi-eye',
   command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
  },
];

this.ncaLinkReinitiatedWithOutVendorOnboarded= [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
  {
   label:'Resend Vendor Link',
   icon:'pi pi-fw pi-pencil',
   command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
  },
 {
   label:'Resend NCA Link',
   icon:'pi pi-fw pi-pencil',
   command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
  }, 
  {
   label:'Download NCA',
   icon:'pi pi-download',
   command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
  },
  {
   label:'History',
   icon:'pi pi-eye',
   command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
  },
];

  this.vendorOnboarded1099 = [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

  this.vendorOnboardedC2CWithNcaNotApproved = [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
   {
    label:'Resend NCA Link',
    icon:'pi pi-fw pi-pencil',
    command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
   },
   {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   }, 
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

this.vendorOnboardedC2CWithNcaApproved = [
  {
    label:'View Vendor Info',
    icon:'pi pi-eye',
    command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
   },
   {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   }, 
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];
this.pendingApprovalTemplateModifiedTemplateRejected1099 = [
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

this.pendingApprovalTemplateModifiedTemplateRejectedC2C = [
  {
    label:'Download NCA',
    icon:'pi pi-download',
    command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
   }, 
   {
    label:'History',
    icon:'pi pi-eye',
    command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
   },
];

  }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.backToSearchService.getBackToSearchSharedData().subscribe(data => this.backToSearchData = data);
    this.selectedColumns = this.defaultSelectedColumns;
    this.checkViewPermission();
    this.getLoggedInUserProfile();
    this.emailLinkResendFormInitialSetup();
    this.emailLinkResendNCAFormInitialSetup();
    this.getEmailLinkValidityHours();
    // this.activeItem = this.menuItems[0];
    const customFilterName = "custom-equals";
      const dateAfter = "date-after";
      const dateBefore = "date-before";
      const notEquals = "not-equals";

      this.matchModeOptions = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
        { label: "Contains", value: FilterMatchMode.CONTAINS }
      ];

      this.matchModeOptionsForDate = [
        { label: "Equals", value: customFilterName },
        { label: "Not Equals", value: notEquals },
        { label: "Greater Than", value: dateAfter },
        { label: "Less Than", value: dateBefore },
      ];

      this.matchModeOptionsForNumeric = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
      ];
      this.matchModeOptionsForDropdown = [
        { label: "Equals", value: customFilterName },
        { label: "Not Equals", value: notEquals },
      ];
      this.filterCondition=[
        {fieldName:"vendorName",type:"basic"},
        {fieldName:"statusName",type:"dropdown"},
        {fieldName:"msaType",type:"dropdown"},
        {fieldName:"isMSATemplateAvailable",type:"dropdown"},
        {fieldName:"isPOTemplateAvailable",type:"dropdown"},
        {fieldName:"isNCATemplateAvailable",type:"dropdown"},
        {fieldName:"isEmailSent",type:"dropdown"},
        //{fieldName: 'isInsuranceExhibit', type: 'dropdown' },
        {fieldName:"createdByName",type:"basic"},
        {fieldName:"createdOn",type:"date"},
        {fieldName:"modifiedByName",type:"basic"},
        {fieldName:"modifiedOn",type:"date"},
        {fieldName:"submittedByEmail",type:"basic"},
        {fieldName:"vendorSubmittedOn",type:"date"},
        
      ];
      
      this.documentTemplateSearchValues = [
        { description: 'All', id: 'All' },
        { description: 'Yes', id: 'Yes' },
        { description: 'No', id: 'No' }
      ];

  }
  ngAfterViewInit() {
    if (this.backToSearchData != null && this.backToSearchData.toPage == 'Vendor Onboard Approval Search Page') {
      console.log(this.backToSearchData);
      this.pageNo = this.backToSearchData.pageNo;
      this.pageSize = this.backToSearchData.pageSize;
      this.sortField = this.backToSearchData.sortField;
      this.sortOrder = this.backToSearchData.sortOrder;
      // this.filters = this.backToSearchData.filters;
      this.showSorting = this.backToSearchData.showSorting;
      this.showFilters = this.backToSearchData.showFilters;
      this.showToggle = this.backToSearchData.showToggle;
      this.selectedColumns = this.backToSearchData.selectedColumns;
      this.tempEventFirst = this.backToSearchData.tempEventFirst;
      this.selectedStatus = this.backToSearchData.selectedStatus;
      this.selectedStatusId = this.backToSearchData.selectedStatusId;
      this.selectedVendorOnboardApprovalStatus = this.backToSearchData.selectedVendorOnboardApprovalStatus;
      this.selectedVendorOnboardApprovalStatusId = this.backToSearchData.selectedVendorOnboardApprovalStatusId;
      this.selectedMSATemplateStatus = this.backToSearchData.selectedMSATemplateStatus;
      this.selectedMSATemplateStatusId = this.backToSearchData.selectedMSATemplateStatusId;
      this.selectedPOTemplateStatus = this.backToSearchData.selectedPoTemplateStatus;
      this.selectedPOTemplateStatusId = this.backToSearchData.selectedPoTemplateStatusId;
      this.selectedNCATemplateStatus = this.backToSearchData.selectedNcaTemplateStatus;
      this.selectedNCATemplateStatusId = this.backToSearchData.selectedNcaTemplateStatusId;
      this.selectedIsEmailSentStatus = this.backToSearchData.selectedIsEmailSentStatus;
      this.selectedIsEmailSentStatusId = this.backToSearchData.selectedIsEmailSentStatusId;
      // this.selectedinsuranceExhibitTemplateStatus = this.backToSearchData.selectedinsuranceExhibitTemplateStatus;
      // this.selectedinsuranceExhibitTemplateStatusId = this.backToSearchData.selectedinsuranceExhibitTemplateStatusId;
      this.allVendorOnboardApprovalStatus = this.backToSearchData.allVendorOnboardApprovalStatus;
      this.selectedMSAType = this.backToSearchData.selectedMSAType;
      this.selectedMSATypeId = this.backToSearchData.selectedMSATypeId;
      this.allMSAType = this.backToSearchData.allMSAType;
      // this.selectedMSATemplateStatus = this.backToSearchData.selectedMSATemplateStatus;
      // this.selectedMSATemplateStatusId = this.backToSearchData.selectedMSATemplateStatusId;
      // this.selectedPOTemplateStatus = this.backToSearchData.selectedPoTemplateStatus;
      // this.selectedPOTemplateStatusId = this.backToSearchData.selectedPoTemplateStatusId;
      // this.selectedNCATemplateStatus = this.backToSearchData.selectedNcaTemplateStatus;
      // this.selectedNCATemplateStatusId = this.backToSearchData.selectedNcaTemplateStatusId;
      this.table.first = this.tempEventFirst;
      this.table.sortField = this.sortField;
      this.table.rows = this.pageSize;
      this.createdOnFilterValue = this.backToSearchData.createdOnFilterValue;
      this.modifiedOnFilterValue = this.backToSearchData.modifiedOnFilterValue;
      this.submittedOnFilterValue = this.backToSearchData.submittedOnFilterValue;

      if (this.sortOrder === 'desc') {
        this.table.sortOrder = 1;
      } else {
        this.table.sortOrder = -1;
      }
      setTimeout(() => {
        for (let i = 0; i < this.filterCondition.length; i++) {
          if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
            for (let j = 0; j < this.backToSearchData.filters[this.filterCondition[i].fieldName].length; j++) {
              if (this.backToSearchData.filters[this.filterCondition[i].fieldName].length == 2 && this.table.filters[this.filterCondition[i].fieldName].length == 1) {
                this.table.filters[this.filterCondition[i].fieldName].push({ matchMode: null, operator: "and", value: null })
              }
              this.table.filters[this.filterCondition[i].fieldName][j].value = this.backToSearchData.filters[this.filterCondition[i].fieldName][j].value;
              this.table.filters[this.filterCondition[i].fieldName][j].matchMode = this.backToSearchData.filters[this.filterCondition[i].fieldName][j].matchMode;
            }
          }
        }
        this.applyFilter();
        this.backToSearchService.setBackToSearchSharedData(null);
        //this.backToSearchService.setBackToSearchChildSharedData(null);
      }, 100)
    }else{
      this.backToSearchService.setBackToSearchSharedData(null);
      //this.backToSearchService.setBackToSearchChildSharedData(null);
      this.getVendorOnboardApprovalStatus();
      this.getVendorOnboardApprovalList();
      this.getMSAType();
      //this.getEmailLinkValidityHours();
      this.emailLinkResendFormInitialSetup();
      this.emailLinkResendNCAFormInitialSetup();
    }
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this.router.navigateByUrl('/login');
  }

  getLoggedInUserProfile()
  {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }
  getMenu(selectedProcessDetails)
  {
    if(!selectedProcessDetails.isMSASelected && !selectedProcessDetails.isPOSelected
      && !selectedProcessDetails.isDDSelected && !selectedProcessDetails.isVoidChequeSelected
      && !selectedProcessDetails.isI9Selected && !selectedProcessDetails.isW9Selected
      && !selectedProcessDetails.isEVerificationSelected && !selectedProcessDetails.isCOISelected)
      {
        this.onlyNCASelected =true;
      }
     this.items = [
      {
        label:'View Vendor Info',
        icon:'pi pi-eye',
        command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
        visible:((selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Onboarded || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Completed || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant) && selectedProcessDetails.hasVendorSubmitted==true && !selectedProcessDetails.isVendorAvailable),
       },
       {
        label:'View Submitted Documents',
        icon:'pi pi-eye',
        command: e => this.viewVendorInfo(this.selectedGridMenuItem.tempVendorId),
        visible:((selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Onboarded || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Completed || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant) && selectedProcessDetails.hasVendorSubmitted==true && selectedProcessDetails.isVendorAvailable),
       },
        {
          label:'Resend Vendor Link',
          icon:'pi pi-fw pi-pencil',
          command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
          visible:((selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && 
          (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Email_Initiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Link_Reinitiated 
          ||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.NCA_Link_Reinitiated && selectedProcessDetails.hasVendorOnboarded=='No')
          || (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant && selectedProcessDetails.hasVendorOnboarded=='No')
          ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor) && !selectedProcessDetails.isVendorAvailable) ||
          //((selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) &&
           //(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant && selectedProcessDetails.hasVendorOnboarded=='No'))
           ((selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && 
          (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Email_Initiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Link_Reinitiated 
          ||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.NCA_Link_Reinitiated && selectedProcessDetails.hasVendorOnboarded=='No')
          || (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant && selectedProcessDetails.hasVendorOnboarded=='No')
          ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor) && selectedProcessDetails.isVendorAvailable && !selectedProcessDetails.onlyNCASelected) 
        },
       {
         label:'Resend NCA Link',
         icon:'pi pi-fw pi-pencil',
         command: e => this.emailLinkResendNCA(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.applicantName, this.selectedGridMenuItem.emailIds, this.selectedGridMenuItem.applicantEmailId),
         visible:((selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && 
         (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Email_Initiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Link_Reinitiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor||selectedProcessDetails.statusId==VendorOnboardProcessStatus.NCA_Link_Reinitiated||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Onboarded && selectedProcessDetails.hasNCAApproved =='No')||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Completed && selectedProcessDetails.hasNCAApproved =='No')||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant && selectedProcessDetails.hasNCAApproved =='No')) && !selectedProcessDetails.isVendorAvailable) ||
         ((selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && 
         (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Email_Initiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Link_Reinitiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor|| selectedProcessDetails.statusId==VendorOnboardProcessStatus.NCA_Link_Reinitiated||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Onboarded && selectedProcessDetails.hasNCAApproved =='No') ||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Completed && selectedProcessDetails.hasNCAApproved =='No') ||(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant && selectedProcessDetails.hasNCAApproved =='No')) && (selectedProcessDetails.isVendorAvailable && selectedProcessDetails.isNCASelected) )
       }, 
        {
         label:'Download NCA',
         icon:'pi pi-download',
         command: e => this.downloadNCAPDF(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.ncaTemplateContent),
         visible:((selectedProcessDetails.isVendorAvailable &&  selectedProcessDetails.isNCASelected && (selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C)) 
         ||(!selectedProcessDetails.isVendorAvailable && (selectedProcessDetails.msaTypeId==MSAType.StandardC2C || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C)))
        },
        {
         label:'History',
         icon:'pi pi-eye',
         command: e => this.getVendorOnboardApprovalHistoryById(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName),
        },
      //   {
      //    label:'Edit Doc Template',
      //    icon:'pi pi-fw pi-pencil',
      //    command: e => this.editDocTemplate(this.selectedGridMenuItem.emailLinkRefId),
      //    visible:((selectedProcessDetails.msaTypeId==MSAType.Special1099 || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Pending_Approval ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Template_Modified))
      //  },
      //  {
      //    label:'Approve Template',
      //    icon:'pi pi-fw pi-pencil',
      //    command: e => this.approveDocTemplate(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId, this.selectedGridMenuItem.emailIds,this.selectedGridMenuItem.applicantEmailId,this.selectedGridMenuItem.msaTypeId,this.selectedGridMenuItem.emailLinkValidityHoursId, this.selectedGridMenuItem.comments),
      //    visible:((selectedProcessDetails.msaTypeId==MSAType.Special1099 || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Pending_Approval ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Template_Modified))
      //  },
      //  {
      //    label:'Reject Template',
      //    icon:'pi pi-fw pi-pencil',
      //    command: e => this.rejectDocTemplate(this.selectedGridMenuItem.tempVendorId,this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId),
      //    visible:((selectedProcessDetails.msaTypeId==MSAType.Special1099 || selectedProcessDetails.msaTypeId==MSAType.SpecialC2C) && (selectedProcessDetails.statusId==VendorOnboardProcessStatus.Pending_Approval ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Template_Modified))  
      //  },
      {
        label:'Resend Email Link',
        icon:'pi pi-fw pi-pencil',
        command: e => this.emailLinkResend(this.selectedGridMenuItem.tempVendorId, this.selectedGridMenuItem.vendorName,this.selectedGridMenuItem.emailLinkRefId,this.selectedGridMenuItem.statusId,this.selectedGridMenuItem.msaTypeId, this.selectedGridMenuItem.emailIds),
        visible:((selectedProcessDetails.msaTypeId==MSAType.Special1099 || selectedProcessDetails.msaTypeId==MSAType.Standard1099) &&(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Email_Initiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Link_Reinitiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant) && !selectedProcessDetails.isVendorAvailable) ||
        ((selectedProcessDetails.msaTypeId==MSAType.Special1099 || selectedProcessDetails.msaTypeId==MSAType.Standard1099) &&(selectedProcessDetails.statusId==VendorOnboardProcessStatus.Email_Initiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Vendor_Link_Reinitiated ||selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Vendor || selectedProcessDetails.statusId==VendorOnboardProcessStatus.Submitted_By_Applicant) && selectedProcessDetails.isVendorAvailable && !this.onlyNCASelected)
      },
     ]
  }
  getVendorOnboardApprovalList()
  {
    this.appliedFilters.push({ field: "loggedInUserId", matchMode: "custom-equals", value: this.loggedInUserProfile.uid })
    this.vendorOnboardApprovalSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.vendorOnboardApprovalSearchSpinner);
    this.vendorOnboardApprovalSearchService.getAllVendorOnboardApprovalList(this.vendorOnboardApprovalSearchParam).subscribe((data: any) => {
      // this.appliedFilters = [];
      this.vendorOnboardApprovalList =data;
      console.log('Vendor Onboard Approval List',data);
      this.totalRecords =(this.vendorOnboardApprovalList === null || this.vendorOnboardApprovalList === undefined || this.vendorOnboardApprovalList.length <= 0 )? 0 : data[0].totalCount;
      this.isshowpaginator=this.vendorOnboardApprovalList.length>0?true:false;
      this.spinner.hide(this.vendorOnboardApprovalSearchSpinner);
     });
  }

  getVendorOnboardApprovalStatus() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.VendorOnboardProcessStatus).subscribe((data: any) => {
    this.allVendorOnboardApprovalStatus = data;
    this.allVendorOnboardApprovalStatus = data.filter(item => item.description !== 'Template Approved' && item.description !== 'Email Resent');
    this.arrAllVendorOnboardApprovalStatus = this.allVendorOnboardApprovalStatus;
    this.arrAllVendorOnboardApprovalStatus.push({categoryId:0,createdBy:0,createdByUser:null,createdOn: null,description:"All",isActive: true,
    lookupCategory: null,
    lookupId: 0,
    lookupOrder: 0,
    modifiedBy: 0,
    modifiedByUser: null,
    modifiedOn: null});
    this.arrAllVendorOnboardApprovalStatus.sort((a, b) => (a.categoryId < b.categoryId) ? -1 : 1);
    this.allVendorOnboardApprovalStatus = this.arrAllVendorOnboardApprovalStatus;
    this.selectedVendorOnboardApprovalStatusId =  this.allVendorOnboardApprovalStatus[0];
  });
}

getMSAType() {
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.MSAType).subscribe((data: any) => {
  this.allMSAType = data;
  this.arrAllMSAType = this.allMSAType;
  this.arrAllMSAType.push({categoryId:0,createdBy:0,createdByUser:null,createdOn: null,description:"All",isActive: true,
  lookupCategory: null,
  lookupId: 0,
  lookupOrder: 0,
  modifiedBy: 0,
  modifiedByUser: null,
  modifiedOn: null});
  this.arrAllMSAType.sort((a, b) => (a.categoryId < b.categoryId) ? -1 : 1);
  this.allMSAType = this.arrAllMSAType;
  this.selectedMSATypeId =  this.allMSAType[0];
});
}

loadVendorOnboardApprovalList(event:LazyLoadEvent)
  { 
    this.appliedFilters = [];
    this.loadEvent=event;
    if(event.first==0)
    {
      this.tempEventFirst=0;
      this.pageNo = 1;
    }
    else {
      this.tempEventFirst=event.first;
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
    this.getVendorOnboardApprovalList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"] != undefined)
    {
      if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonCO = true;
    }
    else{
      this.showAddRuleButtonCO = false;
    }
    }
    if(this.filters["modifiedOn"] != undefined)
    {
      if(this.filters["modifiedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonMO = true;
    }
    else{
      this.showAddRuleButtonMO = false;
    }
    }
    if(this.filters["vendorSubmittedOn"] != undefined)
    {
      if(this.filters["vendorSubmittedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonVSO = true;
    }
    else{
      this.showAddRuleButtonVSO = false;
    }
    }

    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getVendorOnboardApprovalList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  applyFilter()
  {
    if (Object.keys(this.filters).length > 1)
    {
      this.appliedFilters = [];
    for(let i=0;i<this.filterCondition.length;i++)
    {
      if(this.filterCondition[i].type == "checkbox")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value == true)
        {
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"true"}) 
        }
        else if (this.filters[this.filterCondition[i].fieldName][0].value == false){
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"false"}) 
        }
      }
      else if (this.filterCondition[i].type == "basic")
      {
        if(this.filters[this.filterCondition[i].fieldName] !=undefined )
        {
          if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:this.filters[this.filterCondition[i].fieldName][0].value }) 
        }
      }
      else if (this.filterCondition[i].type == "date")
      {
        if(this.filters[this.filterCondition[i].fieldName] !=undefined )
        {
          // for(let j=0; j<= this.filters[this.filterCondition[i].fieldName].length-1; j++)
          // {
          //   if(this.filters[this.filterCondition[i].fieldName][j].value !== null)
          //   this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
          //                             matchMode:this.filters[this.filterCondition[i].fieldName][j].matchMode,
          //                             value: this.datePipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")})
          // }
          if (this.filterCondition[i].fieldName == "createdOn") {
            this.dateFilterValueSet(this.createdOnFilterValue, "createdOn")
          }
          if (this.filterCondition[i].fieldName == "modifiedOn") {
            this.dateFilterValueSet(this.modifiedOnFilterValue, "modifiedOn")
          }
          if (this.filterCondition[i].fieldName == "vendorSubmittedOn") {
            this.dateFilterValueSet(this.submittedOnFilterValue, "vendorSubmittedOn")
          }
          
        }
       
      }
      else if (this.filterCondition[i].type == "numeric")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
        this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                  matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                  value:this.filters[this.filterCondition[i].fieldName][0].value }) 
      }
      // else if (this.filterCondition[i].type == "dropdown") {
      //   if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
      //     if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
      //       if(this.filterCondition[i].fieldName != "All")
      //       {
      //         this.appliedFilters.push({
      //         field: this.filterCondition[i].fieldName,
      //         matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
      //         value: this.filters[this.filterCondition[i].fieldName][0].value
      //       })}
      //     }
      //   }
      // }
      // else if (this.filterCondition[i].type == "customdropdown") {
      //   if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
      //     if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
      //       if(this.filterCondition[i].fieldName != "All")
      //       {
      //         this.appliedFilters.push({
      //         field: this.filterCondition[i].fieldName,
      //         matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
      //         value: this.filters[this.filterCondition[i].fieldName][0].value.description
      //       })}
      //     }
      //   }
      // }
      else if (this.filterCondition[i].type == "dropdown") {
        if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null && this.filters[this.filterCondition[i].fieldName][0].value != 0) {
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value
            })
          }
        }
      }
      if(this.filters['statusName'] !==undefined)
      {
        if (this.filters['statusName'][0].value !== null && this.filters['statusName'][0].value != 0) {
          this.getSelectedVendorOnboardApprovalStatus(this.allVendorOnboardApprovalStatus,this.filters['statusName'][0].value);
        }
        else{
          this.selectedVendorOnboardApprovalStatus= "";
        }
      }
      if(this.filters['msaType'] !==undefined)
      {
        if (this.filters['msaType'][0].value !== null && this.filters['msaType'][0].value != 0) {
          // this.getSelectedEmploymentType(this.allMSAType,this.filters['msaType'][0].value);
          this.selectedMSAType = this.filters['msaType'][0].value;
        }
        else{
          this.selectedMSAType= "";
        }
      }
      if(this.filters['isMSATemplateAvailable'] !==undefined)
      {
        if (this.filters['isMSATemplateAvailable'][0].value !== null && this.filters['isMSATemplateAvailable'][0].value != 0) {
          this.getSelectedMSATemplateStatus(this.documentTemplateSearchValues,this.filters['isMSATemplateAvailable'][0].value)
        }
        else{
          this.selectedMSATemplateStatus= "";
        }
      }
      if(this.filters['isPOTemplateAvailable'] !==undefined)
      {
        if (this.filters['isPOTemplateAvailable'][0].value !== null && this.filters['isPOTemplateAvailable'][0].value != 0) {
          this.getSelectedPOTemplateStatus(this.documentTemplateSearchValues,this.filters['isPOTemplateAvailable'][0].value)
        }
        else{
          this.selectedPOTemplateStatus= "";
        }
      }
      if(this.filters['isNCATemplateAvailable'] !==undefined)
      {
        if (this.filters['isNCATemplateAvailable'][0].value !== null && this.filters['isNCATemplateAvailable'][0].value != 0) {
          this.getSelectedNCATemplateStatus(this.documentTemplateSearchValues,this.filters['isNCATemplateAvailable'][0].value)
        }
        else{
          this.selectedNCATemplateStatus= "";
        }
      }
      if(this.filters['isEmailSent'] !==undefined)
      {
        if (this.filters['isEmailSent'][0].value !== null && this.filters['isEmailSent'][0].value != 0) {
          this.getSelectedIsEmailSentStatus(this.documentTemplateSearchValues,this.filters['isEmailSent'][0].value)
        }
        else{
          this.selectedIsEmailSentStatus= "";
        }
      }
      // if(this.filters['isInsuranceExhibit'] !==undefined)
      //   {
      //     if (this.filters['isInsuranceExhibit'][0].value !== null && this.filters['isInsuranceExhibit'][0].value != 0) {
      //       this.getSelectedinsuranceExhibitTemplateStatus(this.documentTemplateSearchValues,this.filters['isInsuranceExhibit'][0].value)
      //     }
      //     else{
      //       this.selectedinsuranceExhibitTemplateStatus= "";
      //     }
      //   }
    }
    }
    this.appliedFilters.push({ field: "loggedInUserId", matchMode: "custom-equals", value: this.loggedInUserProfile.uid })
    this.searchGlobalFilter = [];
    this.vendorOnboardApprovalSearchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.vendorOnboardApprovalSearchSpinner);
 this.vendorOnboardApprovalSearchService.getAllVendorOnboardApprovalList(this.vendorOnboardApprovalSearchParam).subscribe((data: any) => {
   // this.appliedFilters = [];
   this.vendorOnboardApprovalList =data;
   console.log('Vendor Onboard Approval List',data);
   this.totalRecords =(this.vendorOnboardApprovalList === null || this.vendorOnboardApprovalList === undefined || this.vendorOnboardApprovalList.length <= 0 )? 0 : data[0].totalCount;
   this.isshowpaginator=this.vendorOnboardApprovalList.length>0?true:false;
   this.spinner.hide(this.vendorOnboardApprovalSearchSpinner);
  });
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
     this.appliedFilters = [];
     this.selectedStatus="";
     this.selectedStatusId=undefined;
     this.selectedVendorOnboardApprovalStatus="";
     this.selectedVendorOnboardApprovalStatusId=undefined;
     this.selectedMSAType="";
     this.selectedMSATypeId=undefined;
     this.selectedMSATemplateStatus ="";
    this.selectedMSATemplateStatusId = undefined;
    this.selectedPOTemplateStatus ="";
    this.selectedPOTemplateStatusId = undefined;
    this.selectedNCATemplateStatus ="";
    this.selectedNCATemplateStatusId = undefined;
    this.selectedIsEmailSentStatus ="";
    this.selectedIsEmailSentStatusId = undefined;
    // this.selectedinsuranceExhibitTemplateStatus ="";
    // this.selectedinsuranceExhibitTemplateStatusId = undefined;
    this.createdOnFilterValue = undefined;
    this.modifiedOnFilterValue = undefined;
    this.submittedOnFilterValue = undefined;
    //  this.applyFilter();
    this.getVendorOnboardApprovalList();
  }
  
  applyFilterNew(){
    //this.filters=table.filters;
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }
  
  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  exportVendorOnboardApprovalList() {
    this.applyFilter();
    this.vendorOnboardApprovalSearchParam = 
     {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      searchGlobalFilter: this.searchGlobalFilter,
      sortOrder:this.sortOrder
     };
     this.vendorOnboardApprovalSearchService.ExportVendorOnboardApprovalSearch(this.vendorOnboardApprovalSearchParam).subscribe(res => {
     var blob = new Blob([res.body], { type: res.body.type });
     const file = new File([blob],"VendorOnboardApprovalSearch.xlsx", { type: res.body.type });
     fs.saveAs(file);
     });
  }

  setColumnWidth(value) {
    if (this.showFilters == true && this.showSorting == true) {
      return value + 4 + 'rem'
    } else if (this.showFilters == true || this.showSorting == true) {
      return value + 2 + 'rem'
    }
    else {
      return value + 'rem'
    }
  }

  createdOnFilterData(e: any) {
    this.createdOnFilterValue = e;
    this.applyFilter();
  }
  modifiedOnFilterData(e: any) {
    this.modifiedOnFilterValue = e;
    this.applyFilter();
  }
  submittedOnFilterData(e: any) {
    this.submittedOnFilterValue = e;
    this.applyFilter();
  }
  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datePipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }

  getSelectedMSATemplateStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedMSATemplateStatus= tempStatus[0].description;
    } else {
      return "";
    }
  }
  getSelectedPOTemplateStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedPOTemplateStatus= tempStatus[0].description;
    } else {
      return "";
    }
  }
  getSelectedNCATemplateStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedNCATemplateStatus= tempStatus[0].description;
    } else {
      return "";
    }
  }

  getSelectedIsEmailSentStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedIsEmailSentStatus= tempStatus[0].description;
    } else {
      return "";
    }
  }

  // getSelectedinsuranceExhibitTemplateStatus(status, id) {
  //   if (id != null) {
  //     let tempStatus = status.filter(data => data.id == id);
  //     this.selectedinsuranceExhibitTemplateStatus= tempStatus[0].description;
  //   } else {
  //     return "";
  //   }
  // }

  getVendorOnboardApprovalHistoryById(tempVendorId: number, vendorName : string)
  {
    this.vendorOnboardApprovalHistoryModal = true;
    this.vendorOnboardApprovalHistoryTitle = " ";
    this.vendorOnboardApprovalHistoryTitle = "Vendor Onboard Approval History - " + vendorName;
    this.vendorOnboardApprovalHistoryList =[];
    this.vendorOnboardApprovalSearchService.getVendorOnboardApprovalHistoryById(tempVendorId).subscribe((data:any)=> {
      for(let i=0;i<data.length;i++)
      {
       if (data[i].notes != null) {
         data[i].notes =data[i].notes.replace(/<[^>]+>/g, '');
         if(data[i].notes =='')
         {
           data[i].notes ='';
         }
       }
      }
    this.vendorOnboardApprovalHistoryList = data;
    console.log('Vendor Onboard Approval History',this.vendorOnboardApprovalHistoryList);
    });
  }
  viewVendorOnboardApprovalHistoryDescription(notes) {
    this.vendorOnboardApprovalHistoryDescriptionModal = true;
    this.loadvendorOnboardApprovalViewDescription(notes);
  }
  @ViewChild('vendorOnboardApprovalHistoryDescriptionContainer') vendorOnboardApprovalHistoryDescriptionContainer: ElementRef;
  loadvendorOnboardApprovalViewDescription(data) {
    this.vendorOnboardApprovalHistoryDescriptionContainer.nativeElement.innerHTML = data;
  }  

  emailLinkResendFormInitialSetup(){
    this.emailLinkResendForm=this.fb.group({ 
      comments: new FormControl("", [this.editorMaxLength(10000)]),
      applicantEmailId:new FormControl(''),
      emailLinkValidityHoursId: new FormControl(null, [Validators.required]),
      emailLinkValidityHours: new FormControl(''),
      emailLinkResendEmailAdd: new FormArray([this.fb.group({
      emailId: new FormControl('', [Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
    })])
  });
  }
  
  get emailLinkResendFormControl(){
  return this.emailLinkResendForm.controls;
  }

  emailLinkResendNCAFormInitialSetup(){
    this.emailLinkResendNCAForm=this.fb.group({ 
      comments: new FormControl("", [this.editorMaxLength(10000)]),
      applicantEmailId:new FormControl('',[Validators.required]),
      emailLinkValidityHoursId: new FormControl(null, [Validators.required]),
      emailLinkValidityHours: new FormControl(''),
      emailLinkResendEmailAdd: new FormArray([this.fb.group({
      emailId: new FormControl(''),
    })])
  });
  }
  
  get emailLinkResendNCAFormControl(){
  return this.emailLinkResendNCAForm.controls;
  }
  
  emailLinkResend(tempVendorId: number, vendorName : string, emailLinkRefId: string, statusId: number,msaTypeId:number, emailIds: any){
  this.isEmailLinkResendDialog=true;
  this.emailLinkResendFormInitialSetup();
  this.emailLinkResendDialogTitleC2C = " ";
  this.emailLinkResendDialogTitleC2C = "Resend The Email Link - " + vendorName;
  this.emailLinkResendDialogTitle1099 = " ";
  this.emailLinkResendDialogTitle1099 = "Resend The Vendor Link - " + vendorName;
  this.tempVendorId = tempVendorId;
  this.statusId = statusId;
  this.emailLinkRefId = emailLinkRefId;
  const emailArray = emailIds.split(',').map(email => email.trim());
  const emailLinkResendEmailAdd = this.emailLinkResendForm.get("emailLinkResendEmailAdd") as FormArray;
  emailLinkResendEmailAdd.clear();
  emailArray.forEach(email => {
    const newEmailLinkResendEmailAdd = this.fb.group({
      emailId: new FormControl(email, [Validators.required, Validators.pattern(VMSConstants.emailValidator)]),
    });
    emailLinkResendEmailAdd.push(newEmailLinkResendEmailAdd);
  });
//   const applicantEmail = this.emailLinkResendForm.get('applicantEmailId');
if(msaTypeId==MSAType.StandardC2C || msaTypeId==MSAType.SpecialC2C){
  // applicantEmail.setValidators([Validators.required,Validators.pattern(VMSConstants.emailValidator)]);
  this.isC2CVendor=true;
}
// else{
//   applicantEmail.clearValidators();
//   applicantEmail.setValue('');
//   this.isC2CVendor=false;
// }
// applicantEmail.updateValueAndValidity();
  }

  emailLinkResendNCA(tempVendorId: number, vendorName : string, emailLinkRefId: string, statusId: number,msaTypeId:number, applicantName: string, emailIds: any, applicantEmailId: string){
    this.isEmailLinkResendNCADialog=true;
    this.emailLinkResendNCAFormInitialSetup();
    this.emailLinkResendDialogTitleNCA = " ";
    this.emailLinkResendDialogTitleNCA = "Resend The NCA Link - " + vendorName + " - " + applicantName;
    this.tempVendorId = tempVendorId;
    this.statusId = statusId;
    this.emailLinkRefId = emailLinkRefId;
    const applicantEmail = this.emailLinkResendNCAForm.get('applicantEmailId');
    this.emailLinkResendNCAForm.controls['applicantEmailId'].setValue(applicantEmailId);
    applicantEmail.setValidators([Validators.required,Validators.pattern(VMSConstants.emailValidator)]);
  if(msaTypeId==MSAType.StandardC2C || msaTypeId==MSAType.SpecialC2C){
    this.isC2CVendor=true;
  }
    }
  
  addEmailFieldsEmailLinkResend(i: number){
  let emailLinkResendEmailAdd = this.emailLinkResendForm.get("emailLinkResendEmailAdd") as FormArray;
  let newEmailLinkResendEmailAdd= this.fb.group({
    emailId: new FormControl('',[Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
  });
  emailLinkResendEmailAdd.push(newEmailLinkResendEmailAdd);
  }
  
  removeEmailFieldsEmailLinkResend(i: number) {
  let arr = this.emailLinkResendForm.get("emailLinkResendEmailAdd") as FormArray;
  arr.removeAt(i);
  }
  
  submitEmailLinkResend({value}:{value:IVendorOnboardApprovalEmailLinkResend}){
    value.modifiedBy=Number(this.loggedInUserProfile.uid);
    value.modifiedOn=new Date();
    value.createdBy=Number(this.loggedInUserProfile.uid);
    value.createdOn=new Date();
    value.comments=(this.emailLinkResendForm.controls['comments'].value == null ? null : this.emailLinkResendForm.controls['comments'].value);
    value.emailBody=(this.emailLinkResendForm.controls['comments'].value == null ? null : this.emailLinkResendForm.controls['comments'].value);
    value.emailids = this.emailLinkResendForm.controls['emailLinkResendEmailAdd'].value.map(element => element.emailId).join(",");
    value.emaillinkrefid = this.emailLinkRefId;
    value.statusid = this.statusId;
    value.tempVendorId = this.tempVendorId;
    value.emailLinkValidityHoursId = this.emailLinkValidityHoursId;
    value.emailLinkValidityHours = this.emailLinkValidityHours;
    this.loadingSaveButton = true;
    this.vendorOnboardApprovalSearchService.resendEmailLink(value).subscribe(data => {
    this.loadingSaveButton = false;
    this.isEmailLinkResendDialog = false;
    this.emailLinkResendFormInitialSetup();
    this.messageService.add({severity: 'success', summary: 'Success', detail: 'The email link has been shared with the vendor successfully'});
    this.getVendorOnboardApprovalList();
    this.loading = false;
    });
  }

  submitEmailLinkResendNCA({value}:{value:IVendorOnboardApprovalEmailLinkResend}){
    value.modifiedBy=Number(this.loggedInUserProfile.uid);
    value.modifiedOn=new Date();
    value.createdBy=Number(this.loggedInUserProfile.uid);
    value.createdOn=new Date();
    value.comments=(this.emailLinkResendNCAForm.controls['comments'].value == null ? null : this.emailLinkResendNCAForm.controls['comments'].value);
    value.emailBody=(this.emailLinkResendNCAForm.controls['comments'].value == null ? null : this.emailLinkResendNCAForm.controls['comments'].value);
    value.emailids = "";
    value.emaillinkrefid = this.emailLinkRefId;
    value.statusid = this.statusId;
    value.tempVendorId = this.tempVendorId;
    value.emailLinkValidityHoursId = this.emailLinkValidityHoursId;
    value.emailLinkValidityHours = this.emailLinkValidityHours;
    this.loadingSaveButton = true;
    this.vendorOnboardApprovalSearchService.resendEmailLinkNCA(value).subscribe(data => {
    this.loadingSaveButton = false;
    this.isEmailLinkResendNCADialog = false;
    this.emailLinkResendNCAFormInitialSetup();
    this.messageService.add({severity: 'success', summary: 'Success', detail: 'The email link has been shared with the applicant successfully'});
    this.getVendorOnboardApprovalList();
    this.loading = false;
    });
  }
  
  onCancelEmailLinkResend(){
  this.emailLinkResendFormInitialSetup();
  this.isEmailLinkResendDialog=false;
  }

  onCancelEmailLinkResendNCA(){
    this.emailLinkResendNCAFormInitialSetup();
    this.isEmailLinkResendNCADialog=false;
    }
  
    editorMaxLength(maxlength): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } => {
        var regex = /(<([^>]+)>)/ig;
        var value = control.value;
        if (value == null) {
          return null;
        }
        var result = value.replace(regex, "");
        if (result.length > maxlength) {
          return { 'maxlengthError': true };
        } else {
          return null;
        }
      }
    }
    getSelectedVendorOnboardApprovalStatus(status, id) {
      if (id != null) {
        this.tempStatus = status.filter(data => data.lookupOrder == id);
        this.selectedVendorOnboardApprovalStatus = this.tempStatus[0].description;
      } else {
        return "";
      }
    }

    getSelectedEmploymentType(status, id) {
      if (id != null) {
        this.tempStatus = status.filter(data => data.lookupOrder == id);
        this.selectedMSAType = this.tempStatus[0].description;
      } else {
        return "";
      }
    }

    viewVendorInfo(tempVendorId){
      var data = {
        tempVendorId: tempVendorId
      }
      this.dataService.setSharedData(data);
      let searchData = {
        fromPage: 'Vendor Onboard Approval Search Page',
        toPage: 'Vendor Onboard Approval View Page',
        pageNo:this.pageNo,
        pageSize:this.pageSize,
        sortField:this.sortField,
        sortOrder:this.sortOrder,
        showSorting: this.showSorting,
        showFilters: this.showFilters,
        showToggle: this.showToggle,
        selectedColumns: this.selectedColumns,
        tempEventFirst: this.tempEventFirst,
        filters: this.filters,
        selectedStatus : this.selectedStatus,
        selectedStatusId : this.selectedStatusId,
        // showAddRuleButton: this.showAddRuleButton,
        selectedVendorOnboardApprovalStatus: this.selectedVendorOnboardApprovalStatus,
        selectedVendorOnboardApprovalStatusId: this.selectedVendorOnboardApprovalStatusId,
        allVendorOnboardApprovalStatus: this.allVendorOnboardApprovalStatus,
        selectedMSAType: this.selectedMSAType,
        selectedMSATypeId: this.selectedMSATypeId,
        allMSAType: this.allMSAType,
        selectedMSATemplateStatus: this.selectedMSATemplateStatus,
        selectedMSATemplateStatusId: this.selectedMSATemplateStatusId,
        selectedPOTemplateStatus: this.selectedPOTemplateStatus,
        selectedPOTemplateStatusId: this.selectedPOTemplateStatusId,
        selectedNCATemplateStatus: this.selectedNCATemplateStatus,
        selectedNCATemplateStatusId: this.selectedNCATemplateStatusId,
        selectedIsEmailSentStatus: this.selectedIsEmailSentStatus,
        selectedIsEmailSentStatusId: this.selectedIsEmailSentStatusId,
        // selectedinsuranceExhibitTemplateStatus: this.selectedinsuranceExhibitTemplateStatus,
        // selectedinsuranceExhibitTemplateStatusId: this.selectedinsuranceExhibitTemplateStatusId,
        createdOnFilterValue: this.createdOnFilterValue,
        modifiedOnFilterValue: this.modifiedOnFilterValue,
    
      }
      this.backToSearchService.setBackToSearchSharedData(searchData);
      this.router.navigate(['/admin/vendor-onboard-approval-view',{tempVendorId: tempVendorId}]);
    
    }

downloadNCAPDF(tempVendorId: string, ncaTemplateContent: string){
  this.tempVendorId = tempVendorId;
// let form = this.signFormNCA.value;
// let sign = this.sigNCA.toDataURL();
var html = undefined;
if(ncaTemplateContent.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  ncaTemplateContent= ncaTemplateContent.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(ncaTemplateContent);
  html = htmlToPdfmake(ncaTemplateContent, { removeExtraBlanks: true });
}
else if(ncaTemplateContent.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  ncaTemplateContent= ncaTemplateContent.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(ncaTemplateContent);
  html = htmlToPdfmake(ncaTemplateContent, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(ncaTemplateContent, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
columns: [
  {
    width: '50%',
    text: 'DevCare Solutions, Ltd.',
    bold: true,
    fontSize: 9,
    margin: 0
  },
  {
    width: '50%',
    text: '\n',
    bold: true,
    fontSize: 9,
    margin: 0
  },
],
columnGap: 180
})
ct.push(' ');
ct.push({
columns: [

  {
    width: '50%',
    //text: 'Janakiram Ramakrishnan',
    text:"\n",
    bold: true,
    fontSize: 11
  },
  {
    width: '50%',
    text: '\n',
    bold: true,
    fontSize: 11,
  },

],
columnGap: 180
})

ct.push(
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
{ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
columns: [

  {
    width: '50%',
    text: 'Name (Print)',
    fontSize: 8,
    margin: [0, 2, 0, 0]
  },
  {
    width: '50%',
    text: 'Name (Print)',
    fontSize: 8,
    margin: [0, 2, 0, 0]
  },

],
columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
// columns: [

//   {
//     width: '50%',
//     //text: 'HR Manager',
//     text:"\n",
//     bold: true,
//     fontSize: 11
//   },
//   {
//     width: '50%',
//     text: '\n',
//     // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//     bold: true,
//     fontSize: 11
//   },

// ],
// columnGap: 180
// })

// ct.push(
// { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
// { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
// columns: [

//   {
//     width: '50%',
//     text: 'Title',
//     fontSize: 8,
//     margin: [0, 2, 0, 0]
//   },
//   {
//     width: '50%',
//     text: 'Title',
//     fontSize: 8,
//     margin: [0, 2, 0, 0]
//   },

// ],
// columnGap: 180
// })

// ct.push(' ');
ct.push({
  columns: [
  
    {
      width: '50%',
      // text: 'HR Manager',
      text: '\n\n\n',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: '\n\n\n',
      // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
      bold: true,
      fontSize: 11
    },
  
  ],
  columnGap: 180
  })
// ct.push(' ');
// ct.push({
// table: {
//   widths: [150, 180, 150],
//   body: [
//     [
//       {
//         image: 'hrsignImage',
//         width: '120'
//       },
//       {
//         image: 'userSignImage',
//         width: '120'
//       },
//     ],
//     [
//       {
//         // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       },
//       {

//       },
//       {
//         // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       },
//     ],
//   ]
// },
// layout: 'noBorders'
// })


ct.push(
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
{ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
columns: [

  {
    width: '50%',
    text: 'Signature & Date',
    fontSize: 8,
    margin: [0, 2, 0, 0]
  },
  {
    width: '50%',
    text: 'Signature & Date',
    fontSize: 8,
    margin: [0, 2, 0, 0]
  },

],
columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
value.push(ct[i])
}
var docDefinition: any = {
header:  function(currentPage, pageCount, pageSize) {
  //if (currentPage <= 1) {
  //    return [];
  //}
  return {
    table: {
        widths: [120, 220, 180],
        body: [
            [
              { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
              { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
              { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
            ],
        ],
    },
    layout: 'noBorders',
    margin: [40, 18, 10, 10]
};

},
// pageMargins: [40, 82, 40, 60],
pageMargins: [54, 64, 54, 58],
footer: function (currentPage: any, pageCount: any) {
  return {
    table: {
      widths: '*',
      body: [
        [
          { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
          { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
        ]
      ]
    },
    layout: 'noBorders'
  };
},
permissions: {
  printing: 'highResolution',
  modifying: false,
  copying: false
},
content: value,
defaultStyle: {
  fontSize: 9,
  alignment: 'justify'
},
images: {
  // hrsignImage: this.hrSign,
  // userSignImage: this.sign,
  logoDevCare: this.logoOnLeft,
  logoCMMIISO: this.logoOnRight,
}
};

const pdfDocGenerator = pdfMake.createPdf(docDefinition);
pdfDocGenerator.getBlob((blob) => {
 this.blobFile = blob;
 const url = URL.createObjectURL(blob);
 window.open(url, '_blank');
//  const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
// console.log('blob file', this.blobFile);
//  this.uploadedNCAFile = file;
//  this.documentTypeOnFileUpload = "NCA";
//  this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
//   //  console.log('nca generated',data);
//    this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
//    this.ncaFormUploadedPath = data.result;
//    this.hasNCACompleted = true;
//    this.loadingSaveButton = false;
//  },error => {
//   console.log(error);
//  }
//  );
});
}

viewDocumentTemplate(templateContent: string, isMSAContent: boolean) {
  this.viewDocumentTemplateModal = true;
  this.loadDocumentTemplateContent(templateContent, isMSAContent);
}
@ViewChild('previewDocumentTemplate') documentTemaplatePreviewContainer: ElementRef;
  // logoOnMSA ='data:image/png;base64,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';
  logoOnMSALeft = DocTemplateLogo.DevCareLogo;
  logoOnMSARight = DocTemplateLogo.CMMIISOLogo;
//   loadDocumentTemplateContent(data) {
//   this.documentTemaplatePreviewContainer.nativeElement.innerHTML = data;
// }
loadDocumentTemplateContent(data: string, isMSAContent: boolean) {
  if (isMSAContent) {
    data = data.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
  }
  this.documentTemaplatePreviewContainer.nativeElement.innerHTML = data;
}


insuranceExhibitDownloadFile(insuranceExhibitA:any){
    
  if (insuranceExhibitA >= 1 && insuranceExhibitA <= 6) {
    let link = document.createElement("a");
    link.download = "InsuranceExhibitA.pdf";
    switch (insuranceExhibitA) {
      case 1:
        link.href = "assets/pdf/Standard-ExA.pdf";
        break;
      case 2:
        link.href = "assets/pdf/Knowledge-Service-Ohio-ExA.pdf";
        break;
      case 3:
        link.href = "assets/pdf/Knowledge-Service-Michigan-ExA.pdf";
        break;
      case 4:
        link.href = "assets/pdf/OST-Pennsylvania-ExA.pdf";
        break;
      case 5:
        link.href = "assets/pdf/Computer-Aid-North-Carolina-ExA.pdf";
        break;
      case 6:
        link.href = "assets/pdf/Covendis-CO-OR-GA-ExA.pdf";
        break;
    }
    const fileUrl = window.location.origin + '/' + link.href;
    this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl:link.href,
        title: 'File Preview',
        fileName: link.download,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
    //link.click();
  }
    
  }

  getEmailLinkValidityHours() {
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.EmailLinkValidityHours).subscribe((data: any) => {
    this.allEmailLinkValidityHours = data;
    this.allEmailLinkValidityHours.sort((a: any, b: any) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
    console.log('Email Link Validity Hours', data);
  });
  }

  getEmailLinkValidityHoursOnChange(event) {
    this.emailLinkValidityHoursId = event.value.lookupOrder;
    this.emailLinkValidityHours = event.value.description;

  }

}
